import Token from "../Token";
import { fragmentBoundaryToken } from "./fragmentBoundaryToken";
import { isFragmentationMode } from "./isFragmentationMode";

const cssInjectPointToken = "<!--%%cssInjectionPoint%-->";

const FragmentBoundaryToken = () =>
  isFragmentationMode ? <Token value={fragmentBoundaryToken} /> : null;

const CssInjectionPointToken = () =>
  isFragmentationMode ? <Token value={cssInjectPointToken} /> : null;

export default {
  FragmentBoundaryToken,
  CssInjectionPointToken
};
